import {Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap'
import {withRouter} from 'react-router-dom'
import PropTypes from 'prop-types'

import Modal from '../../../../shared/components//Modals/Modal.jsx'

class ConfirmCloseInterviewModal extends Modal {
  static propTypes = {
    confirmCloseInterview: PropTypes.func.isRequired
  }

  static defaultProps = {
    confirmCloseInterview: () => {}
  }

  constructor(props) {
    super(props)

    this.state = {
      loading: false,
    }
  }

  cancel = () => {
    this.props.closeModal()
  }

  confirm = () => {
    this.props.confirmCloseInterview()
    this.props.closeModal()
  }

  render() {
    const modalProps = {}

    if (!this.state.loading) {
      modalProps.toggle = this.close
    }

    return (
      <BootstrapModal toggle={this.cancel} isOpen={this.props.isOpen}>
        <ModalHeader toggle={this.cancel}>Valider le formulaire</ModalHeader>
        <ModalBody>
          <div className="text-center mb-4">
            Vous vous apprêtez à valider définitivement le formulaire. Aucune modification ne sera possible. Êtes-vous sûr de vouloir clôturer le formulaire ?
          </div>
          <div className="d-flex justify-content-around">
            <button onClick={this.confirm} type="button" className="btn btn-secondary">Oui</button>
            <button onClick={this.cancel} type="button" className="btn btn-primary">Non</button>
          </div>
        </ModalBody>
      </BootstrapModal>
    )
  }
}

export default withRouter(ConfirmCloseInterviewModal)
